module.exports = __webpack_public_path__ + "static/media/C.11012202.svg";